export enum SidebarColorThemesEnum {
    DARK = 0,
    PALE = 1
}
